import { useNotification } from "@itandi/itandi-bb-ui/NotificationBarStore";
import type React from "react";
import { ChatPagesContainer } from "~/components/common/chat/ChatPagesContainer";
import { SERVER_ERROR_MESSAGE } from "~/constants/AppConst";
import { useMessageSummaries } from "~/hooks/vendors/useMessageSummaries";
import { UPDATE_TEMPORARY_UNREAD_MESSAGE } from "~/models/Message";
import { isSuccess } from "~/utils/api/api_handler";
import { postTemporaryUnread } from "~/utils/api/vendors/deals/Message";

export const Page: React.FC = () => {
	const { notify } = useNotification();
	const { data: messageSummaries, mutate: mutateMessageSummaries } =
		useMessageSummaries().index();
	if (messageSummaries === null) {
		return null;
	}
	const handleTemporaryUnread = async (dealId: number): Promise<void> => {
		const result = await postTemporaryUnread(dealId);
		if (isSuccess(result)) {
			await mutateMessageSummaries?.();
			notify({ content: UPDATE_TEMPORARY_UNREAD_MESSAGE, variant: "success" });
			return;
		}
		notify({ content: SERVER_ERROR_MESSAGE, variant: "error" });
	};
	return (
		<ChatPagesContainer
			handleTemporaryUnread={handleTemporaryUnread}
			isVendor
		/>
	);
};
